
import React, { useCallback, useEffect, useRef, useState } from "react";
import ReflectionsPromoPopup from "./reflections-promo-popup";
import SurveyPromoPopup from "./survey-promo-popup";
import BhavanaArcadePromoPopup from "./bhavana-arcade";
import surveyService from "../../services/survey-service";
import { getSurveyIdentity } from "../../utils/surveyIdentity";
import { useUser } from "../context/UserContext";

const SURVEY_DELAY_MS = 2000;

// Reset only on full browser reload — not on SPA home navigation
let hasShownReflectionsThisLoad = false;
let hasAttemptedSurveyThisLoad = false;

const HomePromoPopups = () => {
  const { user } = useUser();
  const [showReflections, setShowReflections] = useState(false);
  const [showBhavanaArcade, setShowBhavanaArcade] = useState(false);
  const [showSurvey, setShowSurvey] = useState(false);
  const surveyTimerRef = useRef(null);

  const tryShowSurveyPopup = useCallback(
    (delay = SURVEY_DELAY_MS) => {
      if (hasAttemptedSurveyThisLoad) return;
      hasAttemptedSurveyThisLoad = true;

      if (surveyTimerRef.current) {
        clearTimeout(surveyTimerRef.current);
      }

      surveyTimerRef.current = setTimeout(async () => {
        try {
          const identity = getSurveyIdentity(user);
          const response = await surveyService.getSurveyStatus(identity);
          const result = response?.data?.result;

          if (result?.hasSubmitted) return;
          if (result?.showSurvey === false) return;

          setShowSurvey(true);
        } catch {
          // Do not block the home page if status check fails
        }
      }, delay);
    },
    [user],
  );

  useEffect(() => {
    // Reflections: show on first land / refresh, once per page load
    if (!hasShownReflectionsThisLoad) {
      hasShownReflectionsThisLoad = true;

      const timer = setTimeout(() => {
        // setShowReflections(true);
        setShowBhavanaArcade(true)
      }, 500);

      return () => {
        clearTimeout(timer);

        if (surveyTimerRef.current) {
          clearTimeout(surveyTimerRef.current);
        }
      };
    }

    return () => {
      if (surveyTimerRef.current) {
        clearTimeout(surveyTimerRef.current);
      }
    };
  }, []);

  const handleReflectionsClose = () => {
    setShowReflections(false);
    tryShowSurveyPopup(SURVEY_DELAY_MS);
  };

  const handleBhavanaArcadeClose = () => {
    setShowBhavanaArcade(false);
  };

  return (
    <>
      {/* <ReflectionsPromoPopup
        show={showReflections}
        onClose={handleReflectionsClose}
      /> */}

      <BhavanaArcadePromoPopup
        show={showBhavanaArcade}
        onClose={handleBhavanaArcadeClose}
      />

      {/* <SurveyPromoPopup
        show={showSurvey}
        onClose={() => setShowSurvey(false)}
      /> */}
    </>
  );
};

export default HomePromoPopups;